import React from 'react';
import '../styles.css';
import { NavLink } from 'react-router-dom';
import Icons from '../../../Icon';

export const ItemMenuAtendimentoVirtual = ({ icone, titulo, destino }) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!destino.startsWith('http') ? (
        <NavLink to={destino} className="item-menu">
          <div className="icon-menu">
            <Icons
              path={icone}
              size={1.7}
              style={{ color: 'var(--primary-color)' }}
              isFont
            />
          </div>
          <div className="mt-4">
            <span>{titulo}</span>
          </div>
        </NavLink>
      ) : (
        <a
          href={destino}
          target="_blank"
          rel="noopener noreferrer"
          className="item-menu"
        >
          <div className="icon-menu">
            <Icons
              path={icone}
              size={2}
              style={{ color: 'var(--primary-color)' }}
              isFont
            />
          </div>
          <div className="mt-4">
            <span>{titulo}</span>
          </div>
        </a>
      )}
    </>
  );
};
